import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Star({ viewBox, active }) {
    return (
        <SvgIcon viewBox={viewBox}>
            <path fill={active ? '#eda821' : '#d6d9dc'} d="M63.7 25.2c-.5.4-.9.8-1.3 1.2-4.8 4.6-9.7 9.1-14.5 13.7-.2.2-.3.4-.3.7l3.3 21v.4c-.2-.1-.3-.2-.5-.2-6.2-3.4-12.3-6.7-18.5-10.1-.3-.2-.5-.2-.8 0-6.2 3.2-12.5 6.3-18.7 9.5-.1.1-.3.1-.5.3l.3-1.8c1.2-6.5 2.4-13.1 3.7-19.6.1-.3 0-.5-.2-.7-5-5-9.9-10-14.9-15-.1-.1-.2-.2-.4-.3 0 0 0-.1.1-.1.5 0 1.1-.1 1.6-.2 5.1-.7 10.1-1.3 15.2-2 1.5-.2 3.1-.4 4.6-.6.3 0 .4-.2.6-.4l9.6-18.9c.1-.1.1-.3.2-.5.4.8.8 1.6 1.1 2.3 2.7 5.7 5.5 11.5 8.2 17.2.1.3.3.4.6.5 4.6.7 9.3 1.5 13.9 2.2 2.5.6 5 1 7.6 1.4z" />
        </SvgIcon>
    );
}

Star.propTypes = {
    viewBox: PropTypes.string,
    active: PropTypes.bool
};

Star.defaultProps = {
    viewBox: '0 0 64 64',
    active: false
};

export default Star;
